import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import { ReplacePrefixUrl, ReplaceText } from '../../config/helper';
import NAimage from '../../img/pic-na.png';

export default class Block extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: '',
      title: '',
      image: '',
      link: '',
      memberStatus: localStorage.getItem('status')
    }
  }

  componentDidMount() {
    var content = this.props.value;
    this.setState({
      id: content.id,
      title: ReplaceText(content.libraryTitle),
      image: (content.libraryPicture !== "" && content.libraryPicture !== undefined)? content.libraryPicture : NAimage,
      link: '/library/' + ReplacePrefixUrl(content.libraryTitle) + '/' + content.id
      // link: (this.state.memberStatus === 'Member' ? '/enroll/' : '/library/') + content.id
    });

  }

  render() { 
    return (
			<a href={this.state.link}>
        <Card className="library-block">
          <Card.Img variant="top" src={this.state.image} alt={"Library " + this.state.title}/>
          <Card.Body className="text-center">
            <Card.Title>{this.state.title}</Card.Title>
          </Card.Body>
        </Card>
      </a>
    )
  }
}